module.exports = __webpack_public_path__ + "singapore.svg?3d05a02d8a92aec1e77b5799e9fb8622";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/singapore.svg
// module id = 291
// module chunks = 10